import React, { useMemo } from 'react';
import { getTranslate } from 'react-localize-redux';
import { Hidden, SubmitButton } from '../../../../ui';
import { paymentSelectors } from '../../../selectors';
import PaymentMethodSelector from './PaymentMethodSelector';
import StripePayButton from './StripePayButton';
import { basketSelectors } from '../../../redux';

interface PaymentSectionProps {
  translate: ReturnType<typeof getTranslate>;
  payments: ReturnType<typeof paymentSelectors.getAvailablePayments>;
  selectedPayment: ReturnType<typeof basketSelectors.getSelectedPaymentOrDefault>;
  loading?: boolean;
  disabled?: boolean;
  onSubmit();
}

const PaymentSection = (props: PaymentSectionProps) => {
  const { payments, selectedPayment, loading, disabled, translate } = props;

  const onSubmit = () => {
    props.onSubmit();
  };

  const placeText = useMemo(() => {
    if (selectedPayment) {
      switch (selectedPayment.PaymentAccountType) {
        case 'BrainTreePayPalPaymentAccount': {
          if (selectedPayment.paymentId === 'paypal') {
            return `${translate('Add_paypal_account_and_pay')}`;
          }
          return selectedPayment.Description;
        }

        case 'CashPaymentAccount':
          return `${translate('Pay_with')} ${translate('Cash_wo')}`;

        case 'CardPaymentAccount': {
          if (selectedPayment.paymentId === 'new_card') {
            return `${translate('Add_card_and_pay')}`;
          }

          const cardNumber =
            selectedPayment.Description.slice(selectedPayment.Description.indexOf('*')) || '';
          return `${translate('Pay_with')} ${translate('Card')} ${cardNumber}`;
        }

        case 'StripePayButtonPaymentAccount':
          if (selectedPayment.Description === 'Apple_pay') {
            return translate('Pay_with_apple_pay');
          }
          return translate('Google_microsoft_pay');

        default:
          return `${translate('Pay_with')} ${translate(selectedPayment.Description, undefined, {
            missingTranslationMsg: selectedPayment.Description
          })}`;
      }
    }

    return translate('Place_order');
  }, [translate, selectedPayment]);

  const noPayments = !payments.length;

  return (
    <>
      <PaymentMethodSelector
        translate={translate}
        payments={payments}
        selectedPaymentId={selectedPayment && selectedPayment.paymentId}
        disabled={disabled || loading}
      />

      {selectedPayment && selectedPayment.paymentId === 'stripe' ? (
        <StripePayButton
          dataFd="checkout-place-order"
          loading={loading}
          disabled={noPayments || disabled}
          onClick={onSubmit}
        />
      ) : (
        <SubmitButton
          dataFd="checkout-place-order"
          loading={loading}
          disabled={noPayments || disabled}
          onClick={onSubmit}
        >
          {placeText}
        </SubmitButton>
      )}

      <Hidden smUp>
        <div style={{ height: '52px' }}></div>
      </Hidden>
    </>
  );
};

export default PaymentSection;
